<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        @if(!isEcommerceUser){
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        }
        @if( rolUser === 'CLIENTE'){
        <a class="layout-topbar-logo" routerLink="/dd/cl">
            <img src="./assets/img/logos/DD512.png" alt="Logo" class="h-10 w-auto" />
            <!-- <span>DistriDent</span> -->
        </a>
        }
        @if(!isEcommerceUser){
        <a class="layout-topbar-logo" routerLink="/dd/cp">
            <img src="./assets/img/logos/DD512.png" alt="Logo" class="h-10 w-auto" />
            <!-- <span>DistriDent</span> -->
        </a>
        }
    </div>

    <!-- Usuario en el centro -->
    <div class="layout-topbar-center">
        <div class="user-info">
            <i class="pi pi-user"></i>
            <span class="user-name">{{ nombreUsuario }}</span>
        </div>
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu">
            <!-- <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i
                    [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
            </button> -->
            <!-- <div class="relative">
                <button class="layout-topbar-action layout-topbar-action-highlight" pStyleClass="@next"
                    enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                    <i class="pi pi-palette"></i>
                </button> -->
            <app-configurator />
            <!-- </div> -->
        </div>

        <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden"
            enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout"
            [hideOnOutsideClick]="true">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">
                @if( rolUser === 'CLIENTE' || rolUser === 'admin' ){

                <button type="button" class="layout-topbar-action" pTooltip="Carrito Compras" tooltipPosition="left"
                    (click)="goto('/dd/cl/shoppingcart')">
                    <i class="pi pi-shopping-cart"></i>
                    <span>Carrito</span>
                </button>

                <!-- <button type="button" class="layout-topbar-action" pTooltip="Favoritos" tooltipPosition="left"
                    (click)="goto('/dd/cl/favorites')">
                    <i class="pi pi-heart"></i>
                    <span>Favoritos</span>
                </button> -->

                }

                <!-- <button type="button" class="layout-topbar-action" pTooltip="Notificaciones" tooltipPosition="left"
                    (click)="goto('/dd/cl/notifications')">
                    <i class="pi pi-inbox"></i>
                    <span>Notificaciones</span>
                </button> -->

                <button type="button" class="layout-topbar-action" pTooltip="Perfil" tooltipPosition="left"
                    (click)="goto('/dd/cl/userdetail')">
                    <i class="pi pi-user"></i>
                    <span>Perfil</span>
                </button>

                <button type="button" class="layout-topbar-action" pTooltip="Salir" tooltipPosition="left"
                    (click)="openConfirmation()">
                    <i class="pi pi-fw pi-sign-out"></i>
                    <span>Logout</span>
                </button>
            </div>
        </div>
    </div>
</div>

<p-dialog styleClass="dialog-compact" [(visible)]="displayConfirmation" [modal]="true" [draggable]="false" [resizable]="false"
    [closable]="false" [dismissableMask]="true" [style]="{ width: '360px', maxWidth: '92vw' }">
    <ng-template #header>
        <span class="font-semibold text-base">Cerrar sesión</span>
    </ng-template>

    <div class="flex flex-col items-center text-center gap-3">
        <span class="flex items-center justify-center w-14 h-14 rounded-full bg-orange-100 text-orange-500 dark:bg-orange-500/20">
            <i class="pi pi-sign-out text-2xl"></i>
        </span>
        <p class="m-0">¿Está seguro que desea cerrar la sesión?</p>
    </div>

    <ng-template #footer>
        <div class="flex justify-end gap-2 w-full">
            <p-button label="No" icon="pi pi-times" severity="secondary" [outlined]="true" size="small"
                (onClick)="closeConfirmation(false)" />
            <p-button label="Sí" icon="pi pi-check" severity="danger" size="small" autofocus
                (onClick)="closeConfirmation(true)" />
        </div>
    </ng-template>
</p-dialog>